import getIsElFocusedById from '../../../../utils/getIsElFocusedById';
import { scrollToIndex } from './scrollTo';
const handleSearchOnType = ({ name, elements, elementIds, key, setSelectedValue }) => {
    const firstViableIdx = elements.findIndex((child) => String(child.props.labelText)
        .toLocaleLowerCase()
        .startsWith(String.fromCharCode(key).toLocaleLowerCase()));
    if (firstViableIdx >= 0) {
        scrollToIndex(name, elements, firstViableIdx);
        setSelectedValue(elementIds[firstViableIdx]);
    }
};
const handleKeyboardEvent = ({ elements, selectedValue, setSelectedValue, isOpen, setOpen, setClosed, setIsEnterPress, setIsEscOrTabPress, name }) => 
// no way to make this less complex
/* eslint-disable sonarjs/cognitive-complexity */
(e) => {
    if (!getIsElFocusedById(name))
        return;
    e.preventDefault();
    e.stopPropagation();
    const elementIds = elements.map((child) => String(child.props.value));
    const selectedElementIdx = elementIds.indexOf(selectedValue || '');
    const lastElementIdx = elementIds.length - 1;
    const firstElementId = elementIds[0];
    const lastElementId = elementIds[lastElementIdx];
    const isFirstElementSelected = selectedValue === firstElementId;
    const isLastElementSelected = selectedValue === lastElementId;
    switch (e.which) {
        case 13: // enter
            setIsEnterPress(true);
            if (isOpen) {
                setClosed();
            }
            else {
                setOpen();
            }
            if (!selectedValue) {
                setSelectedValue(firstElementId);
            }
            break;
        case 9: // tab
        case 27: // esc
            setIsEscOrTabPress(true);
            // new selection has not been made in this branch, so
            // isEnterPress needs resetting
            setIsEnterPress(false);
            break;
        case 35: // end
            scrollToIndex(name, elements, lastElementIdx);
            setSelectedValue(lastElementId);
            break;
        case 36: // home
            scrollToIndex(name, elements, 0);
            setSelectedValue(firstElementId);
            break;
        case 38: // up
            if (selectedValue) {
                if (!isFirstElementSelected) {
                    scrollToIndex(name, elements, selectedElementIdx - 1);
                    setSelectedValue(elementIds[selectedElementIdx - 1]);
                }
            }
            else {
                scrollToIndex(name, elements, lastElementIdx);
                setSelectedValue(lastElementId);
            }
            break;
        case 40: // down
            if (selectedValue) {
                if (!isLastElementSelected) {
                    scrollToIndex(name, elements, selectedElementIdx + 1);
                    setSelectedValue(elementIds[selectedElementIdx + 1]);
                }
            }
            else {
                scrollToIndex(name, elements, 0);
                setSelectedValue(firstElementId);
            }
            break;
        default:
            handleSearchOnType({ name, elements, elementIds, key: e.which, setSelectedValue });
    }
};
/* eslint-enable sonarjs/cognitive-complexity */
export default handleKeyboardEvent;
//# sourceMappingURL=handleKeyboardEvent.js.map